
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CompMeta from '../../meta/LowCodeComponents/RegisterCom';

/**
 * @class NCRegisterCom
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCRegisterCom
 * @label 自定义区域
 *
 */
class NCRegisterCom extends Component {
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
        * @title 是否可见
        * @description 是否可见
        */
        visible: PropTypes.bool,
    }
    static getCompMeta() {
        return CompMeta;
    }

    render() {
        return (
            <div style={{ width: '100%', height: '50px', border: "1px dashed black" }}></div>
        )
    }
}

export default NCRegisterCom;
